/* Mimo — interacciones propias (prefijo mt-). Vanilla, idempotente. */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveals al entrar en pantalla: un solo observer compartido
  var revealObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); revealObs.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function initReveals(root) {
    root.querySelectorAll('.mt-reveal:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      if (!revealObs || reduce) { el.classList.add('mt-visible'); return; }
      revealObs.observe(el);
    });
  }

  // Titular que escribe y borra beneficios
  function initRotador(root) {
    root.querySelectorAll('[data-mt-rota]:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      var palabras = (el.getAttribute('data-mt-rota') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (palabras.length < 2 || reduce) return;
      var i = 0, txt = palabras[0], borrando = true;
      function paso() {
        if (!document.body.contains(el)) return;
        if (borrando) {
          txt = txt.slice(0, -1);
          el.textContent = txt;
          if (!txt) { borrando = false; i = (i + 1) % palabras.length; }
          setTimeout(paso, 45);
        } else {
          var objetivo = palabras[i];
          txt = objetivo.slice(0, txt.length + 1);
          el.textContent = txt;
          if (txt === objetivo) { borrando = true; setTimeout(paso, 2200); } else { setTimeout(paso, 75); }
        }
      }
      setTimeout(paso, 2600);
    });
  }

  // Collage del héroe que se inclina con el ratón
  function initCollage(root) {
    root.querySelectorAll('.mt-collage:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var fuerza = parseFloat(el.dataset.mtFuerza || '6');
      el.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        el.querySelectorAll('.mt-collage__tarjeta').forEach(function (t, k) {
          var f = fuerza * (1 + k * 0.35);
          t.style.transform = 'rotateY(' + (x * f) + 'deg) rotateX(' + (-y * f) + 'deg) translate3d(' + (x * f * 2) + 'px,' + (y * f * 2) + 'px,0)';
        });
      });
      el.addEventListener('mouseleave', function () {
        el.querySelectorAll('.mt-collage__tarjeta').forEach(function (t) { t.style.transform = ''; });
      });
    });
  }

  // Manifiesto: se ilumina palabra a palabra con el scroll
  var manifiestos = [];
  function initManifiesto(root) {
    root.querySelectorAll('.mt-manifiesto__texto:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      var palabras = el.querySelectorAll('.mt-palabra');
      if (reduce) { palabras.forEach(function (p) { p.classList.add('mt-encendida'); }); return; }
      manifiestos.push(el);
    });
    actualizarManifiestos();
  }
  function actualizarManifiestos() {
    manifiestos = manifiestos.filter(function (el) { return document.body.contains(el); });
    manifiestos.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight;
      var progreso = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      progreso = Math.max(0, Math.min(1, progreso));
      var palabras = el.querySelectorAll('.mt-palabra');
      var n = Math.round(progreso * palabras.length);
      palabras.forEach(function (p, k) { p.classList.toggle('mt-encendida', k < n); });
    });
  }
  var tick = false;
  document.addEventListener('scroll', function () {
    if (tick || !manifiestos.length) return;
    tick = true;
    requestAnimationFrame(function () { actualizarManifiestos(); tick = false; });
  }, { passive: true, capture: true });

  // FAQ desplegable
  function initFaq(root) {
    root.querySelectorAll('.mt-faq__pregunta:not([data-mt-init])').forEach(function (btn) {
      btn.dataset.mtInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  // Cifras que cuentan hacia arriba
  function initCifras(root) {
    root.querySelectorAll('[data-mt-cifra]:not([data-mt-init])').forEach(function (el) {
      el.dataset.mtInit = '1';
      var fin = parseFloat(el.getAttribute('data-mt-cifra'));
      var sufijo = el.getAttribute('data-mt-sufijo') || '';
      if (isNaN(fin) || reduce || !('IntersectionObserver' in window)) { el.textContent = (isNaN(fin) ? '' : fin) + sufijo; return; }
      var obs = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        obs.disconnect();
        var t0 = performance.now();
        (function anima(t) {
          var p = Math.min(1, (t - t0) / 1400);
          var v = fin * (1 - Math.pow(1 - p, 3));
          el.textContent = (fin % 1 ? v.toFixed(1) : Math.round(v)) + sufijo;
          if (p < 1) requestAnimationFrame(anima);
        })(t0);
      });
      obs.observe(el);
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root); initRotador(root); initCollage(root); initManifiesto(root); initFaq(root); initCifras(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();

/* Rituales: activa el paso visible y cambia la foto grande */
(function () {
  if (window.__mtRituales) return;
  window.__mtRituales = true;
  function init(root) {
    (root || document).querySelectorAll('[data-mt-rituales]:not([data-mt-ini])').forEach(function (sec) {
      sec.dataset.mtIni = '1';
      var pasos = sec.querySelectorAll('.mt-rituales__paso');
      var fotos = sec.querySelectorAll('.mt-rituales__foto');
      if (!pasos.length) return;
      pasos[0].classList.add('mt-activo');
      if (!('IntersectionObserver' in window)) { pasos.forEach(function (p) { p.classList.add('mt-activo'); }); return; }
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = e.target.getAttribute('data-mt-indice');
          pasos.forEach(function (p) { p.classList.toggle('mt-activo', p === e.target); });
          fotos.forEach(function (f) { f.classList.toggle('mt-activa', f.getAttribute('data-mt-indice') === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
